import {
  REGISTER_EMAIL,
  REGISTER_EMAIL_SUCCESS,
  REGISTER_EMAIL_FAIL,

  ACTIVATE_TOKEN,
  ACTIVATE_TOKEN_SUCCESS,
  ACTIVATE_TOKEN_FAIL,

  GET_TOKEN_LINE,
  GET_TOKEN_LINE_SUCCESS,
  GET_TOKEN_LINE_FAIL,

  VERIFY_TOKEN_LINE,
  VERIFY_TOKEN_LINE_SUCCESS,
  VERIFY_TOKEN_LINE_FAIL,

  GET_TOKEN_LINE_MOBILE,
  GET_TOKEN_LINE_MOBILE_SUCCESS,
  GET_TOKEN_LINE_MOBILE_FAIL,

  VERIFY_TOKEN_LINE_MOBILE,
  VERIFY_TOKEN_LINE_MOBILE_SUCCESS,
  VERIFY_TOKEN_LINE_MOBILE_FAIL

} from '../actions'

const INIT_STATE = {
  registerEmailLoading: false,
  registerEmailError: '',
  registerEmail: [],
  activateTokenLoading: false,
  activateTokenError: '',
  activateToken: [],
  getTokenlineLoading: false,
  getTokenlineError: '',
  getTokenline: [],
  verifyTokenlineLoading: false,
  verifyTokenlineError: '',
  verifyTokenline: [],
  getTokenlineMobileLoading: false,
  getTokenlineMobileError: '',
  getTokenlineMobile: [],
  verifyTokenlineMobileLoading: false,
  verifyTokenlineMobileError: '',
  verifyTokenlineMobile: []
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    /* register email */
    case REGISTER_EMAIL:
      return { ...state, registerEmailLoading: true, registerEmailError: '', saveType: action.payload.registerEmail.saveType }
    case REGISTER_EMAIL_SUCCESS:
      return { ...state, registerEmailLoading: false, registerEmail: action.payload.registerEmail, registerEmailError: '' }
    case REGISTER_EMAIL_FAIL:
      return { ...state, registerEmailLoading: false, registerEmail: [], registerEmailError: action.payload.message }

    /* activete token */
    case ACTIVATE_TOKEN:
      return { ...state, activateTokenLoading: true, activateTokenError: '', saveType: action.payload.activateToken.saveType }
    case ACTIVATE_TOKEN_SUCCESS:
      return { ...state, activateTokenLoading: false, activateToken: action.payload.activateToken, activateTokenError: '' }
    case ACTIVATE_TOKEN_FAIL:
      return { ...state, activateTokenLoading: false, activateToken: [], activateTokenError: action.payload.message }

    /* get token line */
    case GET_TOKEN_LINE:
      return { ...state, getTokenlineLoading: true, getTokenlineError: '', saveType: action.payload.getTokenline.saveType }
    case GET_TOKEN_LINE_SUCCESS:
      return { ...state, getTokenlineLoading: false, getTokenline: action.payload.getTokenline, getTokenlineError: '' }
    case GET_TOKEN_LINE_FAIL:
      return { ...state, getTokenlineLoading: false, getTokenline: [], getTokenlineError: action.payload.message }

    /* verify token line */
    case VERIFY_TOKEN_LINE:
      return { ...state, verifyTokenlineLoading: true, verifyTokenlineError: '', saveType: action.payload.verifyTokenline.saveType }
    case VERIFY_TOKEN_LINE_SUCCESS:
      return { ...state, verifyTokenlineLoading: false, verifyTokenline: action.payload.verifyTokenline, verifyTokenlineError: '' }
    case VERIFY_TOKEN_LINE_FAIL:
      return { ...state, verifyTokenlineLoading: false, verifyTokenline: [], verifyTokenlineError: action.payload.message }


    /* get token lineMobile */
    case GET_TOKEN_LINE_MOBILE:
      return { ...state, getTokenlineMobileLoading: true, getTokenlineMobileError: '', saveType: action.payload.getTokenlineMobile.saveType }
    case GET_TOKEN_LINE_MOBILE_SUCCESS:
      return { ...state, getTokenlineMobileLoading: false, getTokenlineMobile: action.payload.getTokenlineMobile, getTokenlineMobileError: '' }
    case GET_TOKEN_LINE_MOBILE_FAIL:
      return { ...state, getTokenlineMobileLoading: false, getTokenlineMobile: [], getTokenlineMobileError: action.payload.message }

    /* verify token lineMobile */
    case VERIFY_TOKEN_LINE_MOBILE:
      return { ...state, verifyTokenlineMobileLoading: true, verifyTokenlineMobileError: '', saveType: action.payload.verifyTokenlineMobile.saveType }
    case VERIFY_TOKEN_LINE_MOBILE_SUCCESS:
      return { ...state, verifyTokenlineMobileLoading: false, verifyTokenlineMobile: action.payload.verifyTokenlineMobile, verifyTokenlineMobileError: '' }
    case VERIFY_TOKEN_LINE_MOBILE_FAIL:
      return { ...state, verifyTokenlineMobileLoading: false, verifyTokenlineMobile: [], verifyTokenlineMobileError: action.payload.message }


    default:
      return { ...state }
  }
}